import QueryString from 'qs';

async function http(method, path, params = {}, body = null, headers = {}, attachments = null) {
  let options = { method, credentials: 'same-origin' };
  let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  options.headers = new Headers();
  options.headers.append('Content-Type', 'application/json; charset=utf-8');

  if (csrfToken) {
    options.headers.append('X-CSRF-Token', csrfToken);
  }

  if (window.__BEARER__) {
    options.headers.append('Authorization', `Bearer ${window.__BEARER__}`);
  }

  if (body && !attachments) {
    options.body = JSON.stringify(body);
  }

  if (body && (attachments && attachments.length > 0)) {
    var data = new FormData();

    jsonToFormData( body, data );

    for( let file of Array.from(attachments) )
      data.append('attachments[]', file, file.name);

    options.headers.delete('Content-Type');
    options.body = data;
  }

  for (let key in headers) options.headers.append(key, headers[key]);

  return fetch(`${path}?${QueryString.stringify(params, { arrayFormat: 'brackets' })}`, options).then(
    response => {
      if (!response.ok) {
        console.error('response-error', response);
      }
      
      return response.json().catch(error => {
        console.warn('json-response-error', error);
        return {};
      }).then(result => {
          return {
            ...result,
            data: result.data
          };
        });
    }
  ).catch(error => {
      console.log('error-', error);
    })
}

const jsonToFormData = ( body, dataform, hash = null ) => {
  for( let key in body ) {
    let name = key, value = body[key];

    if ( hash && typeof body === 'object' ) name = `${hash}[${key}]`;
    if ( hash && typeof body === 'object' && Array.isArray(body) ) name = `${hash}[]`;

    // console.log('jsontoformdata-name', name, value);

    if ( typeof value === 'object' ) {
      jsonToFormData( value, dataform, name );
    } else {
      dataform.append( name, value );
    }
  }
}

export const Request = {
  get:    (path, params = {})       => http('GET', path, params),
  post:   (path, params = {}, body, attachments) => http('POST', path, params, body, attachments),
  put:    (path, params = {}, body, attachments) => http('PUT', path, params, body, attachments),
  delete: (path, params = {})       => http('DELETE', path, params)
};
